// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { OfflineTrafficService } from '../services/offline-traffic.service';
import { offlineTrafficRequested, offlineTrafficRequestFailed, offlineTrafficRequestSucceeded } from './offline-traffic.actions';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { SnackbarService } from '@coa/app/libs/services/snackbar.service';

@Injectable()
export class OfflineTrafficEffects {

  offlineTrafficRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(offlineTrafficRequested),
      mergeMap((action) => this.offlineTrafficService.getOfflineTraffic(action.timePeriod, action.clientId, action.categoryId)
        .pipe(
          map((offlineTraffic) => offlineTrafficRequestSucceeded({offlineTraffic})),
          catchError(() => of(offlineTrafficRequestFailed())),
        )),
    ), {dispatch: true},
  );

  offlineTrafficRequestFailed$ = createEffect(() =>
    this.actions$.pipe(
      ofType(offlineTrafficRequestFailed),
      tap(() => {
        this.snackbarService.open(marker('Error occurred while loading offline traffic'));
      }),
    ), {dispatch: false},
  );

  constructor(
    private actions$: Actions,
    private store$: Store,
    private snackbarService: SnackbarService,
    private offlineTrafficService: OfflineTrafficService,
  ) {
  }
}
